import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _typeof from '@babel/runtime/helpers/typeof';

function isObject(item) {
  return item !== null && _typeof(item) === 'object' && !Array.isArray(item);
}

function mergeDeep(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  for (var key in source) {
    if (isObject(source[key])) {
      if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
      mergeDeep(target[key], source[key]);
    } else {
      Object.assign(target, _defineProperty({}, key, source[key]));
    }
  }

  return mergeDeep.apply(void 0, [target].concat(sources));
}

function getComponentVariant(oldTheme, variant) {
  // istanbul ignore next
  if (!variant) {
    return oldTheme;
  }

  var variants = oldTheme.variants,
      theme = _objectWithoutProperties(oldTheme, ["variants"]);

  if (variant === 'condensed' && variants && variants[variant]) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return mergeDeep({}, theme, variants[variant]);
  }

  return theme;
}

export { getComponentVariant, isObject };
